import { render, staticRenderFns } from "./PatientinformationForm.vue?vue&type=template&id=4468d59a&"
import script from "./PatientinformationForm.vue?vue&type=script&lang=js&"
export * from "./PatientinformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports